import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AppService } from 'src/app/app.service';
import {JsonCaseTongue, JsonTongue, SimpleTongueDto, TaggerType} from 'src/model/dto';

@Component({
  selector: 'tudi-tongue-location-selector',
  templateUrl: './tongue-location-selector.component.html',
  styleUrls: ['./tongue-location-selector.component.scss']
})
export class TongueLocationSelectorComponent {
  @Input() tongue: SimpleTongueDto
  @Output() onSave: EventEmitter<JsonCaseTongue> = new EventEmitter();

  appService: AppService = inject(AppService);

  isShow = false;
  locations: number[];

  show(): void {
    this.locations = [];
    this.isShow = true;
  }

  isSelected(location: number): boolean {
    return this.locations.indexOf(location) !== -1;
  }

  onClickLocation(location: number): void {
    if (this.isSelected(location)) {
      this.locations.splice(this.locations.indexOf(location), 1);
    } else {
      this.locations.push(location);
    }
  }

  getLocationClass(location: number): string {
    if (this.isSelected(location)) {
      return 'location-selected';
    } else {
      return 'location-normal';
    }
  }

  onClickSave(): void {
    const result: JsonCaseTongue = {
      tongue: {id: this.tongue.id, name: this.tongue.name},
      tongueType: this.tongue.type,
      locations: this.locations,
      tagger: this.Tagger
    };
    this.onSave.emit(result);
    this.isShow = false;
  }

  get Tagger() {
    return {
      id: this.appService.loginInfo.id,
      name: this.appService.loginInfo.name,
      color: this.appService.loginInfo.color
    }
  }

  onClickAll(): void {
    this.locations = [1, 2, 3, 4, 5, 6];
  }

  onClickNone(): void {
    this.locations = [];
  }
}
